import _regeneratorRuntime from "@babel/runtime-corejs2/regenerator";
import _createForOfIteratorHelper from "@babel/runtime-corejs2/helpers/esm/createForOfIteratorHelper";
import _asyncToGenerator from "@babel/runtime-corejs2/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/esm/createClass";
import _defineProperty from "@babel/runtime-corejs2/helpers/esm/defineProperty";

/* tslint:disable:no-any */
import debounce from 'lodash/debounce';
import { SessionManagerStateType } from '@central-products/interface-session-manager';
import { SESSION_MANAGER_BASE_STATE_EXTENSION } from '../constants';
import { MARK_ACTIVE_EVENT_NAMES } from './constants';
import { retryable, RetryableAbortedError } from '../libs/retryable';
import { HTTPError } from '../libs/http-error';
import { abortable } from '../libs/abortable';
export var SessionMarkActiveListenerServiceStrategy = /*#__PURE__*/function () {
  function SessionMarkActiveListenerServiceStrategy(config) {
    _classCallCheck(this, SessionMarkActiveListenerServiceStrategy);

    this.config = config;

    _defineProperty(this, "debouncedUpdate", void 0);

    _defineProperty(this, "debouncedUpdateBound", void 0);

    _defineProperty(this, "abortController", void 0);

    this.debouncedUpdate = debounce(this.updateInvoke, this.config.imAliveDebounceTime, {
      maxWait: this.config.imAliveDebounceMaxWaitTime
    });
    this.debouncedUpdateBound = this.debouncedUpdate.bind(this);
  }

  _createClass(SessionMarkActiveListenerServiceStrategy, [{
    key: "start",
    value: function () {
      var _start = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _iterator, _step, eventName;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _iterator = _createForOfIteratorHelper(MARK_ACTIVE_EVENT_NAMES);

                try {
                  for (_iterator.s(); !(_step = _iterator.n()).done;) {
                    eventName = _step.value;
                    window.addEventListener(eventName, this.debouncedUpdateBound);
                  }
                } catch (err) {
                  _iterator.e(err);
                } finally {
                  _iterator.f();
                }

                this.abortController = new AbortController();

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function start() {
        return _start.apply(this, arguments);
      }

      return start;
    }()
  }, {
    key: "stop",
    value: function () {
      var _stop = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _iterator2, _step2, eventName;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.debouncedUpdate.cancel();
                _iterator2 = _createForOfIteratorHelper(MARK_ACTIVE_EVENT_NAMES);

                try {
                  for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                    eventName = _step2.value;
                    window.removeEventListener(eventName, this.debouncedUpdateBound);
                  }
                } catch (err) {
                  _iterator2.e(err);
                } finally {
                  _iterator2.f();
                }

                if (this.abortController) {
                  _context2.next = 5;
                  break;
                }

                return _context2.abrupt("return");

              case 5:
                if (!this.abortController.signal.aborted) {
                  this.abortController.abort();
                }

                this.abortController = undefined;

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function stop() {
        return _stop.apply(this, arguments);
      }

      return stop;
    }()
  }, {
    key: "update",
    value: function () {
      var _update = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", this.debouncedUpdate());

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function update() {
        return _update.apply(this, arguments);
      }

      return update;
    }()
  }, {
    key: "updateInvoke",
    value: function () {
      var _updateInvoke = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var _this = this;

        var response;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                _context5.next = 3;
                return retryable( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
                  return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                      switch (_context4.prev = _context4.next) {
                        case 0:
                          if (!_this.abortController.signal.aborted) {
                            _context4.next = 2;
                            break;
                          }

                          throw new RetryableAbortedError();

                        case 2:
                          return _context4.abrupt("return", abortable(function () {
                            return _this.config.scClient.imAlive();
                          }, {
                            signal: _this.abortController.signal
                          }));

                        case 3:
                        case "end":
                          return _context4.stop();
                      }
                    }
                  }, _callee4);
                })), {
                  delay: {
                    initialTime: 2000,
                    maxTime: 2000,
                    jitter: false
                  },
                  retry: {
                    maxTime: 10 * 1000,
                    predicate: function predicate(error) {
                      if (error instanceof DOMException && error.name === 'AbortError') {
                        return false;
                      }

                      if (error instanceof HTTPError) {
                        return error.status !== 401;
                      }

                      return !(error instanceof RetryableAbortedError);
                    }
                  }
                });

              case 3:
                response = _context5.sent;

                if (response.success) {
                  _context5.next = 6;
                  break;
                }

                return _context5.abrupt("return");

              case 6:
                this.config.onStateChangedCallback(SessionManagerStateType.LOGGED_IN, response.state);
                _context5.next = 12;
                break;

              case 9:
                _context5.prev = 9;
                _context5.t0 = _context5["catch"](0);

                if (_context5.t0 instanceof HTTPError) {
                  this.config.onStateChangedCallback(SessionManagerStateType.NOT_LOGGED_IN, SESSION_MANAGER_BASE_STATE_EXTENSION);
                }

              case 12:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[0, 9]]);
      }));

      function updateInvoke() {
        return _updateInvoke.apply(this, arguments);
      }

      return updateInvoke;
    }()
  }]);

  return SessionMarkActiveListenerServiceStrategy;
}();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9TZXNzaW9uTWFya0FjdGl2ZUxpc3RlbmVyL1Nlc3Npb25NYXJrQWN0aXZlTGlzdGVuZXJTZXJ2aWNlU3RyYXRlZ3kudHMiXSwibmFtZXMiOlsiZGVib3VuY2UiLCJTZXNzaW9uTWFuYWdlclN0YXRlVHlwZSIsIlNFU1NJT05fTUFOQUdFUl9CQVNFX1NUQVRFX0VYVEVOU0lPTiIsIk1BUktfQUNUSVZFX0VWRU5UX05BTUVTIiwicmV0cnlhYmxlIiwiUmV0cnlhYmxlQWJvcnRlZEVycm9yIiwiSFRUUEVycm9yIiwiYWJvcnRhYmxlIiwiU2Vzc2lvbk1hcmtBY3RpdmVMaXN0ZW5lclNlcnZpY2VTdHJhdGVneSIsImNvbmZpZyIsImRlYm91bmNlZFVwZGF0ZSIsInVwZGF0ZUludm9rZSIsImltQWxpdmVEZWJvdW5jZVRpbWUiLCJtYXhXYWl0IiwiaW1BbGl2ZURlYm91bmNlTWF4V2FpdFRpbWUiLCJkZWJvdW5jZWRVcGRhdGVCb3VuZCIsImJpbmQiLCJldmVudE5hbWUiLCJ3aW5kb3ciLCJhZGRFdmVudExpc3RlbmVyIiwiYWJvcnRDb250cm9sbGVyIiwiQWJvcnRDb250cm9sbGVyIiwiY2FuY2VsIiwicmVtb3ZlRXZlbnRMaXN0ZW5lciIsInNpZ25hbCIsImFib3J0ZWQiLCJhYm9ydCIsInVuZGVmaW5lZCIsInNjQ2xpZW50IiwiaW1BbGl2ZSIsImRlbGF5IiwiaW5pdGlhbFRpbWUiLCJtYXhUaW1lIiwiaml0dGVyIiwicmV0cnkiLCJwcmVkaWNhdGUiLCJlcnJvciIsIkRPTUV4Y2VwdGlvbiIsIm5hbWUiLCJzdGF0dXMiLCJyZXNwb25zZSIsInN1Y2Nlc3MiLCJvblN0YXRlQ2hhbmdlZENhbGxiYWNrIiwiTE9HR0VEX0lOIiwic3RhdGUiLCJOT1RfTE9HR0VEX0lOIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUE7QUFDQSxPQUFPQSxRQUFQLE1BQXFCLGlCQUFyQjtBQUNBLFNBQVNDLHVCQUFULFFBQXdDLDZDQUF4QztBQUNBLFNBQVNDLG9DQUFULFFBQXFELGNBQXJEO0FBQ0EsU0FBU0MsdUJBQVQsUUFBd0MsYUFBeEM7QUFFQSxTQUFTQyxTQUFULEVBQW9CQyxxQkFBcEIsUUFBaUQsbUJBQWpEO0FBQ0EsU0FBU0MsU0FBVCxRQUEwQixvQkFBMUI7QUFDQSxTQUFTQyxTQUFULFFBQTBCLG1CQUExQjtBQU9BLFdBQWFDLHdDQUFiO0FBS0Usb0RBQ21CQyxNQURuQixFQVFFO0FBQUE7O0FBQUEsU0FQaUJBLE1BT2pCLEdBUGlCQSxNQU9qQjs7QUFBQTs7QUFBQTs7QUFBQTs7QUFDQSxTQUFLQyxlQUFMLEdBQXVCVixRQUFRLENBQUMsS0FBS1csWUFBTixFQUFvQixLQUFLRixNQUFMLENBQVlHLG1CQUFoQyxFQUFxRDtBQUNsRkMsTUFBQUEsT0FBTyxFQUFFLEtBQUtKLE1BQUwsQ0FBWUs7QUFENkQsS0FBckQsQ0FBL0I7QUFHQSxTQUFLQyxvQkFBTCxHQUE0QixLQUFLTCxlQUFMLENBQXFCTSxJQUFyQixDQUEwQixJQUExQixDQUE1QjtBQUNEOztBQWxCSDtBQUFBO0FBQUE7QUFBQTtBQUFBOztBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUEsdURBcUI0QmIsdUJBckI1Qjs7QUFBQTtBQXFCSSxzRUFBaUQ7QUFBdENjLG9CQUFBQSxTQUFzQztBQUMvQ0Msb0JBQUFBLE1BQU0sQ0FBQ0MsZ0JBQVAsQ0FBd0JGLFNBQXhCLEVBQW1DLEtBQUtGLG9CQUF4QztBQUNEO0FBdkJMO0FBQUE7QUFBQTtBQUFBO0FBQUE7O0FBeUJJLHFCQUFLSyxlQUFMLEdBQXVCLElBQUlDLGVBQUosRUFBdkI7O0FBekJKO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBOztBQUFBO0FBQUE7QUFBQTs7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTs7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQTZCSSxxQkFBS1gsZUFBTCxDQUFxQlksTUFBckI7QUE3Qkosd0RBK0I0Qm5CLHVCQS9CNUI7O0FBQUE7QUErQkkseUVBQWlEO0FBQXRDYyxvQkFBQUEsU0FBc0M7QUFDL0NDLG9CQUFBQSxNQUFNLENBQUNLLG1CQUFQLENBQTJCTixTQUEzQixFQUFzQyxLQUFLRixvQkFBM0M7QUFDRDtBQWpDTDtBQUFBO0FBQUE7QUFBQTtBQUFBOztBQUFBLG9CQW1DUyxLQUFLSyxlQW5DZDtBQUFBO0FBQUE7QUFBQTs7QUFBQTs7QUFBQTtBQXVDSSxvQkFBSSxDQUFDLEtBQUtBLGVBQUwsQ0FBcUJJLE1BQXJCLENBQTRCQyxPQUFqQyxFQUEwQztBQUN4Qyx1QkFBS0wsZUFBTCxDQUFxQk0sS0FBckI7QUFDRDs7QUFFRCxxQkFBS04sZUFBTCxHQUF1Qk8sU0FBdkI7O0FBM0NKO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBOztBQUFBO0FBQUE7QUFBQTs7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBLGtEQStDVyxLQUFLakIsZUFBTCxFQS9DWDs7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTs7QUFBQTtBQUFBO0FBQUE7O0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7O0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQSx1QkFvRHNETixTQUFTLHdFQUN2RDtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUEsK0JBSU0sS0FBSSxDQUFDZ0IsZUFBTCxDQUFzQkksTUFBdEIsQ0FBNkJDLE9BSm5DO0FBQUE7QUFBQTtBQUFBOztBQUFBLGdDQUtVLElBQUlwQixxQkFBSixFQUxWOztBQUFBO0FBQUEsNERBUVNFLFNBQVMsQ0FBQztBQUFBLG1DQUFNLEtBQUksQ0FBQ0UsTUFBTCxDQUFZbUIsUUFBWixDQUFxQkMsT0FBckIsRUFBTjtBQUFBLDJCQUFELEVBQXVDO0FBQUVMLDRCQUFBQSxNQUFNLEVBQUUsS0FBSSxDQUFDSixlQUFMLENBQXNCSTtBQUFoQywyQkFBdkMsQ0FSbEI7O0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUEsaUJBRHVELElBV3ZEO0FBQ0VNLGtCQUFBQSxLQUFLLEVBQUU7QUFDTEMsb0JBQUFBLFdBQVcsRUFBRSxJQURSO0FBRUxDLG9CQUFBQSxPQUFPLEVBQUUsSUFGSjtBQUdMQyxvQkFBQUEsTUFBTSxFQUFFO0FBSEgsbUJBRFQ7QUFNRUMsa0JBQUFBLEtBQUssRUFBRTtBQUNMRixvQkFBQUEsT0FBTyxFQUFFLEtBQUssSUFEVDtBQUVMRyxvQkFBQUEsU0FBUyxFQUFFLG1CQUFDQyxLQUFELEVBQVc7QUFDcEIsMEJBQUlBLEtBQUssWUFBWUMsWUFBakIsSUFBaUNELEtBQUssQ0FBQ0UsSUFBTixLQUFlLFlBQXBELEVBQWtFO0FBQ2hFLCtCQUFPLEtBQVA7QUFDRDs7QUFFRCwwQkFBSUYsS0FBSyxZQUFZOUIsU0FBckIsRUFBZ0M7QUFDOUIsK0JBQU84QixLQUFLLENBQUNHLE1BQU4sS0FBaUIsR0FBeEI7QUFDRDs7QUFFRCw2QkFBTyxFQUFFSCxLQUFLLFlBQVkvQixxQkFBbkIsQ0FBUDtBQUNEO0FBWkk7QUFOVCxpQkFYdUQsQ0FwRC9EOztBQUFBO0FBb0RZbUMsZ0JBQUFBLFFBcERaOztBQUFBLG9CQXNGV0EsUUFBUSxDQUFDQyxPQXRGcEI7QUFBQTtBQUFBO0FBQUE7O0FBQUE7O0FBQUE7QUEwRk0scUJBQUtoQyxNQUFMLENBQVlpQyxzQkFBWixDQUFtQ3pDLHVCQUF1QixDQUFDMEMsU0FBM0QsRUFBc0VILFFBQVEsQ0FBQ0ksS0FBL0U7QUExRk47QUFBQTs7QUFBQTtBQUFBO0FBQUE7O0FBNEZNLG9CQUFJLHdCQUFpQnRDLFNBQXJCLEVBQWdDO0FBQzlCLHVCQUFLRyxNQUFMLENBQVlpQyxzQkFBWixDQUFtQ3pDLHVCQUF1QixDQUFDNEMsYUFBM0QsRUFBMEUzQyxvQ0FBMUU7QUFDRDs7QUE5RlA7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7O0FBQUE7QUFBQTtBQUFBOztBQUFBO0FBQUE7QUFBQTs7QUFBQTtBQUFBIiwic291cmNlc0NvbnRlbnQiOlsiLyogdHNsaW50OmRpc2FibGU6bm8tYW55ICovXG5pbXBvcnQgZGVib3VuY2UgZnJvbSAnbG9kYXNoL2RlYm91bmNlJztcbmltcG9ydCB7IFNlc3Npb25NYW5hZ2VyU3RhdGVUeXBlIH0gZnJvbSAnQGNlbnRyYWwtcHJvZHVjdHMvaW50ZXJmYWNlLXNlc3Npb24tbWFuYWdlcic7XG5pbXBvcnQgeyBTRVNTSU9OX01BTkFHRVJfQkFTRV9TVEFURV9FWFRFTlNJT04gfSBmcm9tICcuLi9jb25zdGFudHMnO1xuaW1wb3J0IHsgTUFSS19BQ1RJVkVfRVZFTlRfTkFNRVMgfSBmcm9tICcuL2NvbnN0YW50cyc7XG5pbXBvcnQgeyBTQ0NsaWVudCwgU0NDbGllbnRJbUFsaXZlUmVzcG9uc2UgfSBmcm9tICcuLi9saWJzL1NDQ2xpZW50JztcbmltcG9ydCB7IHJldHJ5YWJsZSwgUmV0cnlhYmxlQWJvcnRlZEVycm9yIH0gZnJvbSAnLi4vbGlicy9yZXRyeWFibGUnO1xuaW1wb3J0IHsgSFRUUEVycm9yIH0gZnJvbSAnLi4vbGlicy9odHRwLWVycm9yJztcbmltcG9ydCB7IGFib3J0YWJsZSB9IGZyb20gJy4uL2xpYnMvYWJvcnRhYmxlJztcbmltcG9ydCB7XG4gIFNlc3Npb25NYW5hZ2VyTWFya0FjdGl2ZUxpc3RlbmVyQ29uZmlnLFxuICBTZXNzaW9uTWFuYWdlck1hcmtBY3RpdmVMaXN0ZW5lckludGVyZmFjZSxcbiAgU2Vzc2lvbk1hbmFnZXJTdGF0ZUV4dGVuc2lvblR5cGUsXG59IGZyb20gJy4uL3R5cGVzJztcblxuZXhwb3J0IGNsYXNzIFNlc3Npb25NYXJrQWN0aXZlTGlzdGVuZXJTZXJ2aWNlU3RyYXRlZ3kgaW1wbGVtZW50cyBTZXNzaW9uTWFuYWdlck1hcmtBY3RpdmVMaXN0ZW5lckludGVyZmFjZSB7XG4gIHByaXZhdGUgcmVhZG9ubHkgZGVib3VuY2VkVXBkYXRlOiAoKCkgPT4gdm9pZCkgJiB7IGNhbmNlbDogKCkgPT4gdm9pZDsgZmx1c2g6ICgpID0+IHZvaWQgfTtcbiAgcHJpdmF0ZSByZWFkb25seSBkZWJvdW5jZWRVcGRhdGVCb3VuZDogKCgpID0+IHZvaWQpICYgeyBjYW5jZWw6ICgpID0+IHZvaWQ7IGZsdXNoOiAoKSA9PiB2b2lkIH07XG4gIHByaXZhdGUgYWJvcnRDb250cm9sbGVyPzogQWJvcnRDb250cm9sbGVyO1xuXG4gIGNvbnN0cnVjdG9yKFxuICAgIHByaXZhdGUgcmVhZG9ubHkgY29uZmlnOiBTZXNzaW9uTWFuYWdlck1hcmtBY3RpdmVMaXN0ZW5lckNvbmZpZyAmIHtcbiAgICAgIHNjQ2xpZW50OiBTQ0NsaWVudDtcbiAgICAgIG9uU3RhdGVDaGFuZ2VkQ2FsbGJhY2s6IChcbiAgICAgICAgc3RhdGU6IFNlc3Npb25NYW5hZ2VyU3RhdGVUeXBlLFxuICAgICAgICBzdGF0ZUV4dGVuc2lvbjogU2Vzc2lvbk1hbmFnZXJTdGF0ZUV4dGVuc2lvblR5cGVcbiAgICAgICkgPT4gdm9pZDtcbiAgICB9XG4gICkge1xuICAgIHRoaXMuZGVib3VuY2VkVXBkYXRlID0gZGVib3VuY2UodGhpcy51cGRhdGVJbnZva2UsIHRoaXMuY29uZmlnLmltQWxpdmVEZWJvdW5jZVRpbWUsIHtcbiAgICAgIG1heFdhaXQ6IHRoaXMuY29uZmlnLmltQWxpdmVEZWJvdW5jZU1heFdhaXRUaW1lLFxuICAgIH0pO1xuICAgIHRoaXMuZGVib3VuY2VkVXBkYXRlQm91bmQgPSB0aGlzLmRlYm91bmNlZFVwZGF0ZS5iaW5kKHRoaXMpO1xuICB9XG5cbiAgcHVibGljIGFzeW5jIHN0YXJ0KCkge1xuICAgIGZvciAoY29uc3QgZXZlbnROYW1lIG9mIE1BUktfQUNUSVZFX0VWRU5UX05BTUVTKSB7XG4gICAgICB3aW5kb3cuYWRkRXZlbnRMaXN0ZW5lcihldmVudE5hbWUsIHRoaXMuZGVib3VuY2VkVXBkYXRlQm91bmQpO1xuICAgIH1cblxuICAgIHRoaXMuYWJvcnRDb250cm9sbGVyID0gbmV3IEFib3J0Q29udHJvbGxlcigpO1xuICB9XG5cbiAgcHVibGljIGFzeW5jIHN0b3AoKSB7XG4gICAgdGhpcy5kZWJvdW5jZWRVcGRhdGUuY2FuY2VsKCk7XG5cbiAgICBmb3IgKGNvbnN0IGV2ZW50TmFtZSBvZiBNQVJLX0FDVElWRV9FVkVOVF9OQU1FUykge1xuICAgICAgd2luZG93LnJlbW92ZUV2ZW50TGlzdGVuZXIoZXZlbnROYW1lLCB0aGlzLmRlYm91bmNlZFVwZGF0ZUJvdW5kKTtcbiAgICB9XG5cbiAgICBpZiAoIXRoaXMuYWJvcnRDb250cm9sbGVyKSB7XG4gICAgICByZXR1cm47XG4gICAgfVxuXG4gICAgaWYgKCF0aGlzLmFib3J0Q29udHJvbGxlci5zaWduYWwuYWJvcnRlZCkge1xuICAgICAgdGhpcy5hYm9ydENvbnRyb2xsZXIuYWJvcnQoKTtcbiAgICB9XG5cbiAgICB0aGlzLmFib3J0Q29udHJvbGxlciA9IHVuZGVmaW5lZDtcbiAgfVxuXG4gIHB1YmxpYyBhc3luYyB1cGRhdGUoKTogUHJvbWlzZTxhbnk+IHtcbiAgICByZXR1cm4gdGhpcy5kZWJvdW5jZWRVcGRhdGUoKTtcbiAgfVxuXG4gIHByaXZhdGUgYXN5bmMgdXBkYXRlSW52b2tlKCkge1xuICAgIHRyeSB7XG4gICAgICBjb25zdCByZXNwb25zZTogU0NDbGllbnRJbUFsaXZlUmVzcG9uc2UgPSBhd2FpdCByZXRyeWFibGUoXG4gICAgICAgIGFzeW5jICgpID0+IHtcbiAgICAgICAgICAvKipcbiAgICAgICAgICAgKiBNZXRob2QgYHN0b3BgIHdhcyBpbnZva2VkIGFuZCBhbnkgZnVydGhlciBjYWxscyBzaG91bGQgYmUgcHJldmVudGVkLlxuICAgICAgICAgICAqL1xuICAgICAgICAgIGlmICh0aGlzLmFib3J0Q29udHJvbGxlciEuc2lnbmFsLmFib3J0ZWQpIHtcbiAgICAgICAgICAgIHRocm93IG5ldyBSZXRyeWFibGVBYm9ydGVkRXJyb3IoKTtcbiAgICAgICAgICB9XG5cbiAgICAgICAgICByZXR1cm4gYWJvcnRhYmxlKCgpID0+IHRoaXMuY29uZmlnLnNjQ2xpZW50LmltQWxpdmUoKSwgeyBzaWduYWw6IHRoaXMuYWJvcnRDb250cm9sbGVyIS5zaWduYWwgfSk7XG4gICAgICAgIH0sXG4gICAgICAgIHtcbiAgICAgICAgICBkZWxheToge1xuICAgICAgICAgICAgaW5pdGlhbFRpbWU6IDIwMDAsXG4gICAgICAgICAgICBtYXhUaW1lOiAyMDAwLFxuICAgICAgICAgICAgaml0dGVyOiBmYWxzZSxcbiAgICAgICAgICB9LFxuICAgICAgICAgIHJldHJ5OiB7XG4gICAgICAgICAgICBtYXhUaW1lOiAxMCAqIDEwMDAsXG4gICAgICAgICAgICBwcmVkaWNhdGU6IChlcnJvcikgPT4ge1xuICAgICAgICAgICAgICBpZiAoZXJyb3IgaW5zdGFuY2VvZiBET01FeGNlcHRpb24gJiYgZXJyb3IubmFtZSA9PT0gJ0Fib3J0RXJyb3InKSB7XG4gICAgICAgICAgICAgICAgcmV0dXJuIGZhbHNlO1xuICAgICAgICAgICAgICB9XG5cbiAgICAgICAgICAgICAgaWYgKGVycm9yIGluc3RhbmNlb2YgSFRUUEVycm9yKSB7XG4gICAgICAgICAgICAgICAgcmV0dXJuIGVycm9yLnN0YXR1cyAhPT0gNDAxO1xuICAgICAgICAgICAgICB9XG5cbiAgICAgICAgICAgICAgcmV0dXJuICEoZXJyb3IgaW5zdGFuY2VvZiBSZXRyeWFibGVBYm9ydGVkRXJyb3IpO1xuICAgICAgICAgICAgfSxcbiAgICAgICAgICB9LFxuICAgICAgICB9XG4gICAgICApO1xuXG4gICAgICBpZiAoIXJlc3BvbnNlLnN1Y2Nlc3MpIHtcbiAgICAgICAgcmV0dXJuO1xuICAgICAgfVxuXG4gICAgICB0aGlzLmNvbmZpZy5vblN0YXRlQ2hhbmdlZENhbGxiYWNrKFNlc3Npb25NYW5hZ2VyU3RhdGVUeXBlLkxPR0dFRF9JTiwgcmVzcG9uc2Uuc3RhdGUpO1xuICAgIH0gY2F0Y2ggKGVycm9yKSB7XG4gICAgICBpZiAoZXJyb3IgaW5zdGFuY2VvZiBIVFRQRXJyb3IpIHtcbiAgICAgICAgdGhpcy5jb25maWcub25TdGF0ZUNoYW5nZWRDYWxsYmFjayhTZXNzaW9uTWFuYWdlclN0YXRlVHlwZS5OT1RfTE9HR0VEX0lOLCBTRVNTSU9OX01BTkFHRVJfQkFTRV9TVEFURV9FWFRFTlNJT04pO1xuICAgICAgfVxuICAgIH1cbiAgfVxufVxuIl19